var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('more-divider');
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from './cell-label';
import { BadgeDivider, BadgeDividerClassNames } from './badge-divider';
import { sprintf } from 'sprintf-js';
import { useLang } from '../hooks/use-lang';
import { useComponentPropsFor } from '../context/component-props-context';
export var MoreDividerDefaultProps = {
  minimise: false
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n\n    &:hover {\n      .", " {\n        border-color: ", ";\n      }\n    }\n  "], ["\n    cursor: pointer;\n\n    &:hover {\n      .", " {\n        border-color: ", ";\n      }\n    }\n  "])), BadgeDividerClassNames.sub('badge'), theme.COLOR('primary'))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 500;\n    color: ", ";\n  "], ["\n    font-weight: 500;\n    color: ", ";\n  "])), theme.COLOR('strong'))
});
// -------- Components -------->
var My = {
  Container: styled(BadgeDivider)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""]))),
  Label: styled(CellLabel)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
My.Container = styled(BadgeDivider)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  &:hover {\n    ", " {\n      color: ", ";\n    }\n  }\n"], ["\n  ", ";\n  &:hover {\n    ", " {\n      color: ", ";\n    }\n  }\n"])), ContainerStyles, My.Label, theme.COLOR('primary'));
export var MoreDivider = function (props) {
  var _a = useComponentPropsFor('MoreDivider', MoreDividerDefaultProps, props),
    className = _a.className,
    children = _a.children,
    onClick = _a.onClick,
    count = _a.count,
    minimise = _a.minimise,
    BadgeDividerProps = __rest(_a, ["className", "children", "onClick", "count", "minimise"]);
  var t = useLang();
  var label = minimise ? t('Collapse') : children || sprintf(t('+ %s More'), count);
  return React.createElement(My.Container, __assign({}, BadgeDividerProps, {
    lineVariant: "dotted",
    onClick: onClick,
    className: cls.name(className)
  }), React.createElement(My.Label, {
    tag: "span"
  }, label));
};
// MoreDivider.defaultProps = MoreDividerDefaultProps;
MoreDivider.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;